import { render, staticRenderFns } from "./RightStudentIn.vue?vue&type=template&id=1eff955b&scoped=true&"
import script from "./RightStudentIn.vue?vue&type=script&lang=js&"
export * from "./RightStudentIn.vue?vue&type=script&lang=js&"
import style0 from "./RightStudentIn.vue?vue&type=style&index=0&id=1eff955b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eff955b",
  null
  
)

export default component.exports